import { connect } from 'react-redux';
import { Dispatch, RootState } from 'shared/state';
import { RouteComponentProps, withRouter } from 'react-router';
import {
  selectSite,
  selectPages,
  updateCurrentPage,
  fetchPage,
} from 'shared/state/ducks/sites';
import Preview from './Preview';
import { selectUser } from 'shared/state/misc/oidc';

interface PreviewContainerProps {
  siteId: number;
  basePath: string;
}

const mapStateToProps = (
  state: RootState,
  ownProps: PreviewContainerProps & RouteComponentProps<{}>
) => ({
  site: selectSite(ownProps.siteId)(state),
  pages: selectPages(ownProps.siteId)(state),
  user: selectUser()(state),
});

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: PreviewContainerProps & RouteComponentProps<{}>
) => ({
  updateCurrentPage: (pageVersion: PageVersion) => {
    dispatch(updateCurrentPage(ownProps.siteId, pageVersion));
  },
  fetchPage: (pageId: number) => {
    dispatch(fetchPage(ownProps.siteId, pageId));
  },
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Preview)
);
